import { ObjectUtility } from './object';
import { StringUtility } from './string';
export class FormUtility {
  // custom required that trim the value before validating
  static Required = {
    required: (value: string) => {
      if (StringUtility.isString(value)) {
        return  !!StringUtility.trimIfString(value);
      }
      if (ObjectUtility.isNil(value)) {
        return false;
      }
      return true;
    }
  };
}
